import { render, staticRenderFns } from "./MySwitch.vue?vue&type=template&id=d2dc7b40&scoped=true&"
import script from "./MySwitch.vue?vue&type=script&lang=js&"
export * from "./MySwitch.vue?vue&type=script&lang=js&"
import style0 from "./MySwitch.vue?vue&type=style&index=0&id=d2dc7b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dc7b40",
  null
  
)

export default component.exports